<template>
  <div class="bg-white-900 mb-14 mt-4">
    <div class="container mx-auto">
      <h1 class="capitalize text-5xl text-black-900 mb-7">All catalogs</h1>
      <actions-bar
        select-type="catalogs"
        title="Catalogs total: 340"
        title-class="text-2xl"
        placeholder="Search by name"
      />

      <list-catalogs class="mb-13" />
    </div>
  </div>
</template>

<script>
import ActionsBar from "@/components/base/ActionsBar.vue";
import TabCatalogs from "@/components/tabs/Catalogs.vue";

export default {
  components: {
    "actions-bar": ActionsBar,
    "list-catalogs": TabCatalogs,
  },
};
</script>
